export function createEditorOptions(isDark: boolean, readOnly = false) {
	return {
		language: 'json',
		theme: isDark ? 'vs-dark' : 'vs',
		readOnly,
		automaticLayout: true,
		minimap: { enabled: false },
		scrollBeyondLastLine: false,
		fontSize: 13,
		lineNumbers: 'on' as const,
		folding: true,
		wordWrap: 'off' as const,
	};
}
